<template>
    <main class="register-login">
        <div class="container">
            <Header
                :title="validToken ? 'Actualiza tu clave' : '¿Olvidaste tu clave?'"
                :text="
                    validToken
                        ? 'A la plataforma gratuita para gestionar y planificar el flujo de caja de tu negocio.'
                        : 'No te preocupes, puedes recuperarla ingresando tu correo.'
                "
            />
            <FormChangePassword v-if="validToken" />
            <CardMessage
                v-else
                title="El link ha expirado"
                message="Por seguridad el link de recuperación ha caducado. Solicita nuevamente el cambio de clave."
            >
                <p class="my-6 is-size-7">
                    Recupera nuevamente tu clave
                    <a
                        class="ml-2 has-text-weight-semibold"
                        v-on:click.prevent="$router.push('/recoverypassword')"
                    >
                        Aquí
                    </a>
                </p>
            </CardMessage>
        </div>
    </main>
</template>

<script>
import FormChangePassword from "@/components/signupAndLogin/FormChangePassword.vue";
import Header from "@/components/signupAndLogin/Header";
import CardMessage from "@/components/signupAndLogin/CardMessage";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
    name: "ChangePassword",
    components: {
        Header,
        FormChangePassword,
        CardMessage,
    },
    created() {
        this.SET_RECOVERY_TOKEN(this.$route.params.token);
        // La action rechaza con token inválido/vencido; el estado ya queda en
        // validToken=false (la vista lo muestra) — sin el catch, cada token
        // vencido era un unhandled rejection.
        this.validateRecoveryToken(this.$route.params.token).catch(() => {});
    },
    methods: {
        ...mapActions("userAuth", ["validateRecoveryToken"]),
        ...mapMutations("userAuth", ["SET_RECOVERY_TOKEN"]),
    },
    computed: {
        ...mapState("userAuth", ["recoveryToken", "validToken"]),
    },
};
</script>
